const collection = {
  collect: `/collectApi/api/collect/collect`,
  boxCollect: `/boxCollectApi/v1/newLog`,
  allBoxCollect: `/boxCollectApi/v1/logs`,
  postColletApi: `/postColletApi/api/collect/collect`,
  // sdk
  sdkCollect: `/authApi/trilateral/mutual/pre/payment/report`
};

export default collection;
